/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APIEmailAddress } from './APIEmailAddress';
import {
    APIEmailAddressFromJSON,
    APIEmailAddressFromJSONTyped,
    APIEmailAddressToJSON,
} from './APIEmailAddress';

/**
 * 
 * @export
 * @interface APIPaginatedEmailAddressList
 */
export interface APIPaginatedEmailAddressList {
    /**
     * 
     * @type {number}
     * @memberof APIPaginatedEmailAddressList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedEmailAddressList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof APIPaginatedEmailAddressList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<APIEmailAddress>}
     * @memberof APIPaginatedEmailAddressList
     */
    results: Array<APIEmailAddress>;
}

/**
 * Check if a given object implements the APIPaginatedEmailAddressList interface.
 */
export function instanceOfAPIPaginatedEmailAddressList(value: object): value is APIPaginatedEmailAddressList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function APIPaginatedEmailAddressListFromJSON(json: any): APIPaginatedEmailAddressList {
    return APIPaginatedEmailAddressListFromJSONTyped(json, false);
}

export function APIPaginatedEmailAddressListFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIPaginatedEmailAddressList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(APIEmailAddressFromJSON)),
    };
}

export function APIPaginatedEmailAddressListToJSON(value?: APIPaginatedEmailAddressList | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(APIEmailAddressToJSON)),
    };
}

